export default __webpack_public_path__ + "static/media/adams_bridge.f690bd81.jpg";